import { render, staticRenderFns } from "./ImmoappLogin.vue?vue&type=template&id=6f04e329&"
import script from "./ImmoappLogin.vue?vue&type=script&lang=js&"
export * from "./ImmoappLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports